import React, { Component } from "react";
import LeftSideNavigation from "../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import SimpleReactLightbox from "simple-react-lightbox";
// import HomeReusableTopBarNavigation from "../../superAdminComponents/superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { ViewOpenIssuesTicketLeft } from "../../superAdminComponents/superAdminAllComponent/superAdminOpenIssuesUsers/ViewUsersTickets/ViewOpenIssuesTicketLeft";
import { ViewOpenIssuesTicketRightVendor } from "../../superAdminComponents/superAdminAllComponent/superAdminOpenIssuesUsers/ViewUsersTickets/ViewOpenIssuesTicketRightVendor";
import CallingButtonPopup from "../../reusableComponents/allPopupReusable/CallingButtonPopup";
import SendSmsButton from "../../reusableComponents/allPopupReusable/SendSmsButton";
import NotificationButton from "../../reusableComponents/allPopupReusable/NotificationButton";
import { PopupIconButtonReusable } from "../../reusableComponents/allPopupReusable/allPopupReusableIconButton/PopupIconButtonReusable";
import ViewButtonPopup from "../../reusableComponents/allPopupReusable/ViewButtonPopup";
import moment from "moment";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import {
  comment_vendor_users_tickets,
  update_vendor_users_tickets_status,
  get_vendor_single_users_tickets,
} from "../../../store/actions/VendorUsersTicketsActions/vendorUsersTicketsActions";
import isEmpty from "../../../store/validation/is-Empty";
import { Button, Col, Image } from "react-bootstrap";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import ChatWindow from "../../vendorDashboardComponents/seatingDashboard/seatingDashboard/ChatWindow";

export class VendorUserOpenIssuesView extends Component {
  constructor(props) {
    super();
    this.state = {
      allViewData: {},
      detailsProps: {},
      dinerInfo: {},
      dinerInfoUserDetails: {},
      userInfo: {},
      refrenceImages: [],
      comment: [],
      contactDetails: [],
      enquiryEmails: "",
      displayChatScreen: false,
      issueDetails: [],
      showChat: false,
      showLog: true,
      message: "",
    };
  }

  componentDidMount() {
    let ticketId =
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.vendorUserTickets;
    const token = this.props.auth.user.accessToken;
    this.props.get_vendor_single_users_tickets(ticketId, token);
    // if (
    //   this.props.location.state !== null &&
    //   this.props.location.state !== undefined
    // ) {
    //   if (this.props.location.state.vendorUserTickets) {
    //     this.setState({
    //       allViewData: this.props.location.state.vendorUserTickets,
    //       detailsProps: this.props.location.state.vendorUserTickets
    //         .restaurant_id,
    //       dinerInfo: this.props.location.state.vendorUserTickets.diner_id,
    //       // dinerInfoUserDetails:
    //       //   this.props.location.state.vendorUserTickets.diner_id
    //       //     .user_details !== null &&
    //       //   this.props.location.state.vendorUserTickets.diner_id
    //       //     .user_details !== undefined
    //       //     ? this.props.location.state.vendorUserTickets.diner_id
    //       //         .user_details
    //       //     : null,
    //       userInfo: this.props.location.state.vendorUserTickets.user_id,
    //       refrenceImages: this.props.location.state.vendorUserTickets
    //         .refrence_images,
    //       comment: this.props.location.state.vendorUserTickets.comment,
    //       contactDetails: this.props.location.state.vendorUserTickets
    //         .restaurant_id.contact_detail[0],
    //       enquiryEmails: this.props.location.state.vendorUserTickets
    //         .restaurant_id.enquiry_email[0],
    //       issueDetails: this.props.location.state.vendorUserTickets,
    //     });
    //   }
    // }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (nextProps.singleTicket !== nextState.allViewData) {
      return {
        allViewData: !isEmpty(nextProps.singleTicket)
          ? nextProps.singleTicket
          : {},
        detailsProps: !isEmpty(nextProps.singleTicket.restaurant_id)
          ? nextProps.singleTicket.restaurant_id
          : {},
        dinerInfo: !isEmpty(nextProps.singleTicket.diner_id)
          ? nextProps.singleTicket.diner_id
          : {},
        // dinerInfoUserDetails:
        //   this.props.location.state.vendorUserTickets.diner_id
        //     .user_details !== null &&
        //   this.props.location.state.vendorUserTickets.diner_id
        //     .user_details !== undefined
        //     ? this.props.location.state.vendorUserTickets.diner_id
        //         .user_details
        //     : null,
        userInfo: !isEmpty(nextProps.singleTicket.user_id)
          ? nextProps.singleTicket.user_id
          : {},
        refrenceImages: !isEmpty(nextProps.singleTicket.refrence_images)
          ? nextProps.singleTicket.refrence_images
          : {},
        comment: !isEmpty(nextProps.singleTicket.comment)
          ? nextProps.singleTicket.comment
          : {},
        // contactDetails:
        //   nextProps.singleTicket.restaurant_id.contact_detail !== undefined
        //     ? nextProps.singleTicket.restaurant_id.contact_detail
        //     : [],
        // enquiryEmails: !isEmpty(
        //   nextProps.singleTicket.restaurant_id.enquiry_email
        // )
        //   ? nextProps.singleTicket.restaurant_id.enquiry_email
        //   : "",
        issueDetails: !isEmpty(nextProps.singleTicket)
          ? nextProps.singleTicket
          : [],
      };
    }
  }

  // componentDidUpdate(prevProps, prevState) {
  //   console.log(prevProps);
  //   if (
  //     this.props.location.state !== null &&
  //     this.props.location.state !== undefined
  //   ) {
  //     if (this.props.location.state.vendorUserTickets) {
  //       this.setState({
  //         allViewData: this.props.location.state.vendorUserTickets,
  //       });
  //     }
  //   }
  // }

  onChangeScreenChat = (e) => {
    this.setState({
      displayChatScreen: !this.state.displayChatScreen,
    });
  };

  renderResolutionLogBody = () => {
    const { allViewData } = this.state;
    if (!isEmpty(allViewData)) {
      return allViewData.ticketLogs.map((data, index) => (
        <React.Fragment key={index}>
          <tr>
            <td>
              <div>
                <h4>{moment(data.time).format("Do MMM YYYY")}</h4>
                <h4>{moment(data.time).format("hh:mm A")}</h4>
              </div>
            </td>
            <td>{data.content}</td>
            <td>{data.initiator}</td>
          </tr>
        </React.Fragment>
      ));
    } else {
      return null;
    }
  };

  handleChatSHow = () => {
    this.setState({
      showChat: true,
      showLog: false,
    });
  };
  handleLogSHow = () => {
    this.setState({
      showChat: false,
      showLog: true,
    });
  };

  setMessage = (data) => {
    this.setState({
      message: data,
    });
  };

  onClickAddComment = () => {
    const token = this.props.auth.user.accessToken;
    const formData = {};
    formData.comment = this.state.message;
    formData.comment_type = "TEXT";

    this.props.comment_vendor_users_tickets(
      formData,
      token,
      this.state.allViewData._id,
      this.clearMessage
    );
  };

  clearMessage = () => {
    this.setState({ message: "" });
    let ticketId =
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.vendorUserTickets;
    const token = this.props.auth.user.accessToken;
    this.props.get_vendor_single_users_tickets(ticketId, token);
    this.setState({ message: "" });
  };

  onSuccessChangeTicketStatus = (handleClose) => {
    handleClose();
  };
  onErrorChangeTicketStatus = (handleClose) => {
    handleClose();
  };

  onSubmitHandler = (status, handleClose) => (e) => {
    const token = this.props.auth.user.accessToken;
    let ticketId =
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.vendorUserTickets;
    const formData = {};
    formData.status = status;
    this.props.update_vendor_users_tickets_status(
      formData,
      token,
      this.state.allViewData._id,
      this.onSuccessChangeTicketStatus,
      this.onErrorChangeTicketStatus,
      handleClose
    );
    this.props.get_vendor_single_users_tickets(ticketId, token);
  };

  render() {
    const {
      allViewData,
      detailsProps,
      dinerInfo,
      dinerInfoUserDetails,
      userInfo,
      refrenceImages,
      comment,
      contactDetails,
      enquiryEmails,
      issueDetails,
      showChat,
      showLog,
    } = this.state;
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>
            {/* <div className="super-admin-right-side-panel"> */}
            <div className="right-side-panel">
              {/* <HomeReusableTopBarNavigation
                displayText={`Ticket No: ${allViewData.ticket_number}`}
                displayBack={true}
                backButtonLink="/vendoruseropenissues"
              /> */}
              <RightSideNavigation // leftText="vendorReview"
              // backButtonLink="/seatingdashboard"
              // displayText="Open User Tickets"
              // displayButton="addOpenIssuesUsers"
              />
              <Col className="d-flex flex-wrap pb-3 pl-0 pr-0 mobile-mt-4">
                <Col md={6} className="pt-4 mobile-mt-4">
                  <NavLink
                    to="/vendoruseropenissues"
                    className="f12-500 enBackLink"
                  >
                    <Image
                      fluid
                      alt="Back Icon"
                      title="Back Icon"
                      className="mr-2"
                      src={require("../../../assets/images/UserManagement/backIcon.svg")}
                    />
                    Back
                  </NavLink>
                  <div className="f24_700_HelveticaNeue">
                    Ticket Number : {allViewData.ticket_number}
                  </div>
                </Col>
                <Col
                  md={6}
                  className="d-flex align-items-end justify-content-end"
                >
                  {showLog && (
                    <Button
                      variant="danger"
                      className="btn2 btn-lg"
                      onClick={this.handleChatSHow}
                    >
                      Submit Response
                    </Button>
                  )}
                  {showChat && (
                    <Button
                      variant="danger"
                      className="btn2 btn-lg"
                      onClick={this.handleLogSHow}
                    >
                      View Log
                    </Button>
                  )}
                </Col>
              </Col>
              <div className="super-admin-inside-right-side-panel pt-4 pb-4 container-fluid">
                <div className="row">
                  <div className="col-lg-5 pr-lg-0">
                    <SimpleReactLightbox>
                      <ViewOpenIssuesTicketLeft
                        sendDataProps={allViewData}
                        detailsProps={detailsProps}
                        dinerInfoUserDetails={dinerInfoUserDetails}
                        dinerInfo={dinerInfo}
                        userInfo={userInfo}
                        refrenceImages={refrenceImages}
                        contactDetails={contactDetails}
                        enquiryEmails={enquiryEmails}
                        issueDetails={issueDetails}
                        onSubmit={this.onSubmitHandler}
                      />
                    </SimpleReactLightbox>
                  </div>
                  <div className="col-lg-7 pl-lg-2">
                    <ViewOpenIssuesTicketRightVendor
                      message={this.state.message}
                      setMessage={(data) => this.setMessage(data)}
                      onClickAddComment={this.onClickAddComment}
                      auth={this.props.auth}
                      logData={allViewData}
                      showLog={showLog}
                      showChat={showChat}
                      onClickShowLog={this.handleLogSHow}
                      handleChatSHow={this.handleChatSHow}
                      dinerInfo={dinerInfo}
                      dinerInfoUserDetails={dinerInfoUserDetails}
                      sendDataProps={allViewData}
                      tableBody={this.renderResolutionLogBody()}
                      // callingButton={
                      //   <CallingButtonPopup
                      //     buttonClass="smallButton"
                      //     dataSend={dinerInfo}
                      //   />
                      // }
                      // SendSmsButton={
                      //   <SendSmsButton
                      //     buttonClass="smallButton"
                      //     dataSend={dinerInfo}
                      //   />
                      // }
                      // SendNotificationButton={
                      //   <NotificationButton
                      //     buttonClass="smallButton"
                      //     dataSend={dinerInfo}
                      //   />
                      // }
                      // chatButton={
                      //   // <PopupIconButtonReusable
                      //   //   buttonClass={"smallButton"}
                      //   //   titleText="Send Sms Button"
                      //   //   image={require("../../../assets/images/ActionImages/chat.png")}
                      //   //   // onClick={this.onOpenModal}
                      //   // />
                      //   <ChatWindow data={dinerInfo} text="seating" />
                      // }
                      viewButton={
                        <ViewButtonPopup
                          buttonClass="smallButton"
                          // dataSend={dinerInfo}
                        />
                      }
                      displayInput={false}
                      displayChatScreen={this.state.displayChatScreen}
                      displayChatScreenFunc={this.onChangeScreenChat}
                      comment={comment}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

VendorUserOpenIssuesView.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  singleTicket: state.vendorUsersTickets.vendor_get_single_user_ticket,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  comment_vendor_users_tickets,
  update_vendor_users_tickets_status,
  get_vendor_single_users_tickets,
})(withRouter(VendorUserOpenIssuesView));
